module.exports = __webpack_public_path__ + "img/capture-back.2cc62935.png";